<script lang="ts">
import FilterSelect from "./FilterSelect.svelte";
import Chip from "./Chip.svelte";
import {Utils} from "./util";
import {translations} from "./config";
import YesNoSelect from "./YesNoSelect.svelte";
import type {YesNoOption} from "./yes-no-option";

export let selectedQuestionAnswers: { [id: number]: boolean } = {};
export let selectedElection: number | null = null;
export let questionOptions: YesNoOption[] = [];

export let isPhoneSize = false;

// let questionOptions: { value: number, label: string }[] = [];
const electionOptions: { value: number, label: string }[] = [{
	label: Utils.chooseTranslation(translations.voting.relative),
	value: -3000
}, {
	label: Utils.chooseTranslation(translations.voting.proportional),
	value: +2999
}];

function clear() {
    selectedQuestionAnswers = null;
    // TODO: selectedCommunities = [];
    selectedElection = null;
}

function removeAnswer(question_id: number) {
    delete selectedQuestionAnswers[question_id];
    selectedQuestionAnswers = {...selectedQuestionAnswers};
}

</script>

<div class="flex-row w-100 filter-select">
<!--    <FilterSelect bind:value={selectedQuestion} label="{Utils.chooseTranslation(translations.question)}"-->
<!--                  options={questionOptions} containerStyle="width: 100%; margin-right: 0.3rem; margin-bottom: 0;"/>-->
    <YesNoSelect bind:values={selectedQuestionAnswers} label="{Utils.chooseTranslation(translations.question)}"
                 options={questionOptions}
                 {isPhoneSize} containerStyle="width: 100%; margin-right: 0.3rem; margin-bottom: 0;"/>
<!--    <FilterSelect bind:value={selectedAnswer} label="{Utils.chooseTranslation(translations.answer)}"-->
<!--                  options={answerOptions} containerStyle="width: 100%; margin-right: 0.3rem; margin-bottom: 0;"/>-->
    <FilterSelect bind:value={selectedElection} label="{Utils.chooseTranslation(translations.voting.label)}" showSearch="{false}"
                  options={electionOptions}
                  {isPhoneSize} containerStyle="width: 100%; margin-right: 0.3rem; margin-bottom: 0;"/>
    <button class="reset-btn" on:click={clear}
            disabled="{selectedElection == null && selectedQuestionAnswers == null}">
        {Utils.chooseTranslation(translations.reset)}
    </button>
</div>
<div class="flex-row flex-wrap w-100" style="margin-bottom: 0;">
    {#if selectedQuestionAnswers}
        {#each Object.entries(selectedQuestionAnswers) as [question_id, answer]}
            <Chip style="margin-right: 0.2rem"
                  label="{questionOptions.find(q => q.id === Number(question_id))?.label}"
                  on:delete={() => removeAnswer(question_id)}>
                <img style="width: 22px; height: 22px;" class="mr-1" alt="{answer ? 'yes' : 'no'}" src="img/answer-box-{answer}.svg" slot="start">
            </Chip>
        {/each}
    {/if}
    {#if selectedElection != null}
        <Chip label="{electionOptions.find(e => e.value === selectedElection)?.label}"
              on:delete={() => selectedElection = null}/>
    {/if}
</div>
<div class="flex-row w-100">
    {Utils.chooseTranslation(translations.filter)}
</div>

<style>
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }

    .reset-btn {
        border: 2px solid #FE6D50;
        background: white;
        color: inherit;
        outline: none;
        margin-bottom: 0;
    }
    .reset-btn:disabled {
        border-color: #FE6D5080;
    }
    .reset-btn:active {
        background: #FE6D50;
    }
</style>
